import { createFileRoute } from "@tanstack/react-router";
import DepressionTreatmentCoralSprings from "@/pages/local/DepressionTreatmentCoralSprings";
export const Route = createFileRoute("/depression-treatment-coral-springs")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Depression Treatment Coral Springs | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression treatment in Coral Springs, FL. SAINT® TMS, SPRAVATO®, ketamine, and therapy for major depressive disorder at Neuro Wellness TMS.",
        },
        {
          property: "og:title",
          content: "Depression Treatment Coral Springs | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression treatment in Coral Springs, FL. SAINT® TMS, SPRAVATO®, ketamine, and therapy for major depressive disorder at Neuro Wellness TMS.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/depression-treatment-coral-springs",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/depression-treatment-coral-springs",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DepressionTreatmentCoralSprings />;
}
